import type { LeaderboardConfig } from "./types";

/**
 * Spec defaults from 01-leaderboard-config.md. The "simplest case is one line"
 * — every field has a sensible default so a board needs only an `id`.
 */
export function defaultConfig(id = "", name = ""): LeaderboardConfig {
  return {
    id,
    name: name || id,
    sort_order: "desc",
    score_type: "i64",
    display_as: "numeric",
    update_method: "keep_best",
    aggregation: undefined,
    tiebreaker: ["earliest_submission"],
    reset: null,
    archive_policy: { kind: "keep_all" },
    max_entries: null,
    unique_by: "player_id",
    write_auth: "server_only",
    rate_limit: null,
    visibility: "public",
    entry_metadata_schema: null,
  };
}

export const DISPLAY_AS_LABELS: Record<string, string> = {
  numeric: "Numeric",
  seconds: "Seconds",
  milliseconds: "Milliseconds",
  time_hms: "Time (h:m:s)",
  percentage: "Percentage",
  currency: "Currency",
};

/** Render a raw score using the board's display hint (cosmetic only). */
export function formatScore(score: number, displayAs: string): string {
  switch (displayAs) {
    case "seconds":
      return `${score.toLocaleString()}s`;
    case "milliseconds":
      return `${score.toLocaleString()}ms`;
    case "percentage":
      return `${score.toLocaleString()}%`;
    case "currency":
      return score.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
      });
    case "time_hms": {
      const total = Math.floor(score);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    }
    default:
      return score.toLocaleString();
  }
}
